<template>
  <div>
    <div v-for="item in values" :key="item.label">
      <asc-descriptions-item
        :label="item.label"
        :value="item.value"
      ></asc-descriptions-item>
    </div>
  </div>
</template>

<script>
import AscDescriptionsItem from './AscDescriptionsItem'

export default {
  name: 'AscDescriptionsList',

  components: {
    AscDescriptionsItem,
  },

  props: {
    values: {
      type: Array,
      required: true,
    },
  },
}
</script>

<style lang="scss" scoped>
.asc-descriptions-list--margins {
  margin-top: $size-sm;
}
</style>
